export default {
    appDownloadUrl: '',
    campaignLanguages: []
}